const d = (o) => ({
  card: {
    borderRadius: 8,
    padding: 16,
    border: `1px solid ${o.palette.common.grey20}`,
    boxShadow: `0px 2px 8px 0px ${o.palette.common.grey400}0d`,
    width: "100%"
  }
}), e = d;
export {
  e as default
};
